import React, { useEffect, useState } from "react";
import { CalendarClock, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// 'YYYY-MM-DDTHH:MM' -> { date:'GG/MM/AAAA', time:'HH:MM' }
const parse = (dt) => {
  if (!dt || dt.length < 16) return null;
  const [d, t] = dt.split("T");
  const [y, mo, da] = d.split("-");
  return { date: `${da}/${mo}/${y}`, time: t };
};

// Preavviso mostrato a TUTTI gli utenti loggati nei giorni precedenti a una
// manutenzione programmata. Chiudibile (per quella specifica finestra).
const MaintenanceNoticeBanner = () => {
  const { user, maintenance } = useAuth();
  const noticeId = `${maintenance?.notice_start || ""}|${maintenance?.notice_end || ""}`;
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(noticeId !== "|" && localStorage.getItem("tb_maint_notice_dismissed") === noticeId);
  }, [noticeId]);

  if (!user) return null;
  if (!maintenance?.notice_active || maintenance?.active) return null;
  if (dismissed) return null;

  const s = parse(maintenance.notice_start);
  const e = parse(maintenance.notice_end);
  if (!s || !e) return null;

  const when = s.date === e.date
    ? `il ${s.date} dalle ${s.time} alle ${e.time}`
    : `dal ${s.date} ore ${s.time} al ${e.date} ore ${e.time}`;

  const hide = () => { localStorage.setItem("tb_maint_notice_dismissed", noticeId); setDismissed(true); };

  return (
    <div
      data-testid="maintenance-notice-banner"
      className="relative w-full z-[59] bg-[#0d6cb8] text-white shadow-[0_2px_12px_rgba(0,0,0,0.2)]"
    >
      <div className="max-w-[1200px] mx-auto px-4 py-2 flex items-center gap-3">
        <CalendarClock size={16} className="shrink-0" />
        <p className="text-[12.5px] font-semibold flex-1 leading-snug" data-testid="maintenance-notice-banner-msg">
          Manutenzione programmata {when}. In quella fascia oraria il portale potrebbe non essere disponibile.
        </p>
        <button
          onClick={hide}
          data-testid="maintenance-notice-banner-dismiss"
          className="p-1 rounded-lg hover:bg-white/20 transition-colors shrink-0"
          aria-label="Nascondi avviso"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default MaintenanceNoticeBanner;
